import React, { type PropsWithChildren, useRef, useState } from 'react';

import { Box, Fade, Typography, useTheme } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';

import { useWindowEvent } from '@shared/hooks/useWindowEvent';
import {
  ActionMenuBase,
  ActionMenuBaseItem,
} from '@shared/ui-kit/action-menus/BaseActionMenu/BaseActionMenu.style';
import { MuiTooltip } from 'shared/ui-kit';

import type { ActionMenuListModel } from '@shared/models/actionMenuList.model';

type RightClickContextMenuProps = {
  menuList: ActionMenuListModel;
  isHideMenu?: boolean;
};
export const RightClickContextMenu = (props: PropsWithChildren<RightClickContextMenuProps>) => {
  const { children, menuList, isHideMenu } = props;
  const theme = useTheme();
  const isSmallDisplay = useMediaQuery(`${theme.breakpoints.down('sm')}`);

  const [isOpen, setIsOpen] = useState(false);
  const [menuPosition, setMenuPosition] = useState({ x: 0, y: 0 });
  const menuRef = useRef(null);

  const handleContextMenu = (event: any) => {
    event.preventDefault();

    if (isHideMenu) return;

    if (menuRef.current && (menuRef.current as Node).contains(event.target)) {
      setMenuPosition({ x: event.clientX, y: event.clientY });
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  };

  useWindowEvent('contextmenu', (event) => {
    event.stopPropagation();
  });

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <Box
      ref={menuRef}
      sx={{ height: '100%', width: '100%' }}
      onContextMenu={handleContextMenu}
      onClick={handleClose}
    >
      <Box sx={{ height: '100%', width: '100%' }}>{children}</Box>

      <ActionMenuBase
        open={isOpen}
        onClose={handleClose}
        anchorReference="anchorPosition"
        anchorPosition={isOpen ? { top: menuPosition.y, left: menuPosition.x } : undefined}
        hideBackdrop
        TransitionComponent={Fade}
      >
        {menuList?.map((item, index) =>
          item.isDisabled ? (
            <MuiTooltip
              key={typeof item.label === 'string' ? item.label : index}
              placement={isSmallDisplay ? 'top' : 'left'}
              title={item?.tooltipTitle ? item?.tooltipTitle : ''}
            >
              <Box onClick={() => (item.disableCallback ? item.disableCallback() : true)}>
                <ActionMenuBaseItem disabled sx={{ width: '100% !important' }}>
                  {item.startIcon && <item.startIcon />}
                  <Typography variant="t14r" color={theme.palette.case.neutral.n400}>
                    {item?.label}
                  </Typography>
                </ActionMenuBaseItem>
              </Box>
            </MuiTooltip>
          ) : (
            <ActionMenuBaseItem
              sx={{ width: '100% !important' }}
              key={typeof item.label === 'string' ? item.label : index}
              onClick={(e) => {
                handleClose();
                e.stopPropagation();
                item.callback();
              }}
            >
              {item.startIcon && <item.startIcon />}
              <Typography variant="t14r" color={theme.palette.case.neutral.n700}>
                {item?.label}
              </Typography>
            </ActionMenuBaseItem>
          ),
        )}
      </ActionMenuBase>
    </Box>
  );
};
